import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { StorageService } from '@inshared/shared/util-storage';

@Injectable({
    providedIn: 'root',
})
export class InsocialBtnService {
    public cynolyticsCode: string | null = null;

    constructor(@Inject(StorageService) private storage: Storage, @Inject(PLATFORM_ID) private platformId: Object) {
        if (isPlatformBrowser(this.platformId)) {
            this.cynolyticsCode = this.storage.getItem('__cynolytics');
        }
    }

    public createUrl(sId: number, source: string | null = null): string {
        return `https://survey.insocial.nl/classic/?sId=${sId}&sToken=w9pstr74wz&reset=1&var1=&var2&=var3=${this.cynolyticsCode}&var4=${source}`;
    }
}
